module.exports = __webpack_public_path__ + "media/images/lb/964-b4742c69a5ade56e3c0c625168b743fe.svg";